import * as RadioGroup from '@radix-ui/react-radio-group';
import { forwardRef } from 'react';
import { SurveyRadioItem } from './survey-radio-item';
import { classNames } from '~/utils/classNames';

export interface Data {
  workplace?: Workplace;
}

type Workplace = 'solo' | 'vc-startup' | 'small' | 'mid' | 'large' | 'agency';

const WORKPLACES: Array<{ key: Workplace; value: string; icon: string; note?: string }> = [
  { key: 'solo', value: 'Freelancer / Solo', icon: 'i-bolt:laptop' },
  { key: 'vc-startup', value: 'Venture Backed Startup', icon: 'i-heroicons:rocket-launch' },
  { key: 'small', value: 'Small Business', icon: 'i-heroicons:building-storefront', note: '(under 200 people)' },
  { key: 'mid', value: 'Mid-size Company', icon: 'i-heroicons:building-office', note: '(200-1,000 people)' },
  { key: 'large', value: 'Large Enterprise', icon: 'i-heroicons:building-office-2', note: '(1,000+ people)' },
  { key: 'agency', value: 'Agency or Consultancy', icon: 'i-heroicons:star' },
];

interface Props {
  initialValues?: Data;
  className?: string;
}

const SurveyStep2 = forwardRef<HTMLDivElement, Props>(({ initialValues, className }, ref) => (
  <div className={className} ref={ref}>
    <h2 className="text-[32px]/[39px] font-semibold">What best describes your workplace?</h2>

    <RadioGroup.Root
      defaultValue={typeof initialValues?.workplace === 'string' ? initialValues?.workplace : undefined}
      name="workplace"
      aria-label="Workplace"
      className="mt-8 grid grid-cols-3 justify-center gap-3"
      required
    >
      {WORKPLACES.map((workplace) => (
        <SurveyRadioItem
          key={workplace.key}
          value={workplace.key}
          id={`workplace-${workplace.key}`}
          className="aspect-square px-2 justify-center items-center flex flex-col text-sm"
        >
          <span className={classNames('size-12 mb-4', workplace.icon)} />

          <div className="min-h-10 grid content-center">
            <div className="font-semibold">{workplace.value}</div>
            {workplace.note && <div className="text-bolt-ds-textSecondary ">{workplace.note}</div>}
          </div>
        </SurveyRadioItem>
      ))}
    </RadioGroup.Root>
  </div>
));

SurveyStep2.displayName = 'SurveyStep2';

export default SurveyStep2;
